import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { Provider } from 'react-redux';
import reducers from '../reducers';
import App from './App';
import CartConfirmation from '../cartConfirmation/CartConfirmation';
import Cookies from 'js-cookie';
import aemReactPolyfill from '../../../aem-react-polyfill';
import ppUtilities from '../ppUtilities';

// Solve ModelManager issues on ie 11
aemReactPolyfill.init();

// redux store
const store = createStore(reducers, {}, applyMiddleware(thunk));

window.addEventListener('DOMContentLoaded', () => {
	let flyoutWrapper = document.querySelector('.flyout-wrapper');
	while (!flyoutWrapper) {
		let wrapper = document.createElement('div');
		wrapper.classList.add('flyout-wrapper', 'faded-in');
		document.body.appendChild(wrapper);
		flyoutWrapper = document.querySelector('.flyout-wrapper');
	}

	ReactDOM.render(
		<Provider store={store}>
			<CartConfirmation appWrapper={flyoutWrapper} />
		</Provider>,
		flyoutWrapper
	);

	/* Render */
	let bundleApps = [].slice.call(document.querySelectorAll('[data-app-root="BundleCard"]'));

	let ctID = `ct_${ppUtilities.create_UUID()}`;
	let countryCode = (function getCountryCode() {
		return Cookies.get('omniCoutryCode'); // check if cookie exist.
	})();
	if (!countryCode) {
		ppUtilities.getCountryCode(); // set country code on cookie for later use.
	}
	if (bundleApps && bundleApps.length) {
		bundleApps.forEach((appWrapper, indx) => {
			let bundleInfo = {};
			const cardTitleElm = appWrapper.querySelector('.card-title');
			const cardDescElm = appWrapper.querySelector('.bundle-description');
			const cardMoreElem = appWrapper.querySelector('.moreinfo');
			const ctaElm = appWrapper.querySelector('.cta-trigger');
			const errorMessgElm = appWrapper.querySelector('.bundle-error-mssg');
			const bundleAddedMssgElm = appWrapper.querySelector('.bundle-added-mssg');
			const priceTermElm = appWrapper.querySelector('[data-price-terms]');
			const staticPriceElm = appWrapper.querySelector('[data-static-price]');
			const isLast = indx + 1 === bundleApps.length;

			bundleInfo.title = cardTitleElm ? cardTitleElm.innerText : '';
			bundleInfo.desc = cardDescElm ? cardDescElm.innerHTML : '';
			bundleInfo.moreinfo = cardMoreElem ? cardMoreElem.innerText : '';
			bundleInfo.ctaTrigger = ctaElm ? ctaElm.innerText : '';
			bundleInfo.bundleErrorMessg = errorMessgElm ? errorMessgElm.innerText : '';
			bundleInfo.bundleAddedMssg = bundleAddedMssgElm ? bundleAddedMssgElm.innerText : '';
			bundleInfo.priceTerm = priceTermElm ? priceTermElm.getAttribute('data-price-terms') : '';
			bundleInfo.staticPrice = staticPriceElm ? staticPriceElm.getAttribute('data-static-price') : {};

			bundleInfo.prodConfigArr = [];
			let prodItems = [].slice.call(appWrapper.querySelectorAll('[data-product]'));
			prodItems.forEach((item) => {
				bundleInfo.prodConfigArr.push(item.getAttribute('data-product'));
			});

			ReactDOM.render(
				<Provider store={store}>
					<App key={indx} ctID={ctID} appWrapper={appWrapper} countryCode={countryCode} bundleInfo={bundleInfo} total={bundleApps.length} isLast={isLast} />
				</Provider>,
				appWrapper
			);
		});
	}
});
